import { gql } from '@apollo/client';

export const RevokeMcpConnection = gql`
  mutation McpRevokeConnection($id: ID!) {
    revokeMcpConnection(id: $id) {
      success
      customErrors {
        field
        code
        message
      }
    }
  }
`;
